var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightSquareIcon = function SvgArrowRightSquareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.95.975H6.125A5.075 5.075 0 0 0 1.05 6.05v5.825a5.075 5.075 0 0 0 5.075 5.075h5.825a5.074 5.074 0 0 0 5.075-5.075V6.05A5.075 5.075 0 0 0 11.95.975",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.143 17.048H5.857a4.93 4.93 0 0 1-4.92-4.92V5.834A4.92 4.92 0 0 1 5.858.922h6.286a4.92 4.92 0 0 1 4.92 4.913v6.292a4.93 4.93 0 0 1-4.92 4.92m-6.286-15a3.795 3.795 0 0 0-3.794 3.787v6.292a3.803 3.803 0 0 0 3.794 3.795h6.286a3.803 3.803 0 0 0 3.794-3.795v-6.29a3.795 3.795 0 0 0-3.794-3.788zm2.866 10.125 2.617-2.73a.75.75 0 0 0 0-1.066L8.588 5.76a.753.753 0 1 0-1.043 1.087l2.205 2.1-2.1 2.19a.75.75 0 0 0 .54 1.268.75.75 0 0 0 .533-.232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgArrowRightSquareIcon;